<template>
  <kendo-dropdownlist
    v-model="responsibleEmail"
    :data-source="usersClientDataSource"
    :data-text-field="'email'"
    :data-value-field="'email'"
    :autoWidth="true"
  ></kendo-dropdownlist>
</template>
<script>
export default {
  props: ['value'],
  computed: {
    responsibleEmail: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.$emit('change', newValue)
      },
    },
  },
  data() {
    return {
      usersClientDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/config/Client/getResponsibles',
            contentType: 'application/json',
            type: 'GET',
          },
        },
      }),
    }
  },
}
</script>
